const isProd = process.env.NODE_ENV === 'production';
// console.log('当前环境',isProd);
const config = isProd ? require('./production.js').default : require('./development.js').default;
export default {
	...config
}
